/**
 * In dev the Vite proxy forwards /v1 to the API, so an empty base URL means
 * same-origin. In production the booking app is served from its own host and
 * talks to the API host directly.
 */
export function getApiBaseUrl(): string {
  const configured = import.meta.env.VITE_LUMO_API_BASE_URL?.trim();
  if (!configured || import.meta.env.DEV) {
    return '';
  }
  return configured.replace(/\/+$/, '');
}

/** The guest's own IANA timezone, so every time is shown where they live. */
export function getGuestTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}
